export default __webpack_public_path__ + "static/media/480_business02-en-web.b23c96ab.png";